import {Box} from '@mantine/core';
import type {FC} from 'react';
import {HOWTV_COMPANY_ADDRESS} from '../../../core/entities/shared/howtvInfo';
import {SectionTitle} from '../../../shared/components/SectionTitle';

const TEXT_CLASSNAME = 'leading text-black-1 text-base';

export const Declaration: FC = () => {
  return (
    <>
      <SectionTitle order={2} title="個人情報保護方針" />
      <Box className="mb-16 bg-white px-8 py-16 pc:px-32">
        <div className="mb-16">
          <p className={`${TEXT_CLASSNAME} text-right `}>
            {' '}
            制定年月日&nbsp;2018年9月18日
          </p>
          <p className={`${TEXT_CLASSNAME} text-right `}>
            最終改正年月日&nbsp;2026年4月27日
          </p>
          <p className={`${TEXT_CLASSNAME} text-right `}>
            株式会社ハウテレビジョン
          </p>
          <p className={`${TEXT_CLASSNAME} text-right `}>
            代表取締役社長 音成&nbsp;洋介
          </p>
        </div>
        <div className="mb-16">
          <p className={`${TEXT_CLASSNAME}`}>
            当社は、当社が取り扱う全ての個人情報の保護について、社会的使命を十分に認識し、
            本人の権利の保護、個人情報に関する法規制等を遵守します。
            また、以下に示す方針を具現化するための個人情報保護マネジメントシステムを構築し、
            最新のＩＴ技術の動向、社会的要請の変化、経営環境の変動等を常に認識しながら、
            その継続的改善に、全社を挙げて取り組むことをここに宣言します。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            ａ）個人情報は、キャリアプラットフォーム運営事業における当社の正当な事業遂行上並びに従業員の雇用、人事管理上必要な範囲に限定して、取得・利用及び提供をし、特定された利用目的の達成に必要な範囲を超えた個人情報の取扱い（目的外利用）を行いません。
            また、目的外利用を行わないための措置を講じます。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            ｂ）個人情報保護に関する法令、国が定める指針及びその他の規範を遵守致します。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            ｃ）個人情報の漏えい、滅失、き損などのリスクに対しては、
            合理的な安全対策を講じて防止すべく事業の実情に合致した経営資源を注入し個人情報セキュリティ体制を継続的に向上させます。
            また、個人情報保護上、問題があると判断された場合には速やかに是正措置を講じます。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            ｄ）個人情報取扱いに関する苦情及び相談に対しては、迅速かつ誠実に、適切な対応をさせていただきます。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            ｅ）個人情報保護マネジメントシステムは、当社を取り巻く環境の変化を踏まえ、適時・適切に見直してその改善を継続的に推進します。
          </p>
        </div>
        <div>
          <p className="mb-12 bg-background-1 px-8 py-4 text-md font-bold leading text-black-1">
            【お問合せ窓口】
          </p>
          <p className="mb-12 text-base leading text-black-1">
            個人情報保護方針に関するお問合せにつきましては、下記窓口で受付けております。
          </p>
          <p className="text-sm leading text-black-1 pc:text-base">
            株式会社ハウテレビジョン&nbsp;&nbsp;個人情報問合せ窓口
          </p>
          <p className="text-sm leading text-black-1 pc:text-base">
            {HOWTV_COMPANY_ADDRESS}
          </p>
          <p className="text-sm leading text-black-1 pc:text-base">
            メールアドレス：soumu@howtelevision.jp
          </p>
          <p className="text-sm leading text-black-1 pc:text-base">
            TEL：03-6427-2862
          </p>
          <p className="text-sm leading text-black-1 pc:text-base">
            （受付時間&nbsp;10:00～19:00&nbsp;&nbsp;※土・日曜日、祝日、年末年始、ゴールデンウィークを除く）
          </p>
        </div>
      </Box>
    </>
  );
};
